import { render } from "./PreferredLang.vue?vue&type=template&id=5501c26a&scoped=true"
import script from "./PreferredLang.vue?vue&type=script&lang=js"
export * from "./PreferredLang.vue?vue&type=script&lang=js"

import "./PreferredLang.vue?vue&type=style&index=0&id=5501c26a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5501c26a"]])

export default __exports__